// GENERATED by scripts/build-shared.cjs from functions/src/shared/moneyish.js — DO NOT EDIT.
// TASK-10269: attaches window.Moneyish ("$1,250.00" → 1250); maintenance.js reads it at CALL time.
(function () {
  'use strict';

  function parseMoneyish(v) {
    if (typeof v === 'number') return isFinite(v) ? v : 0;
    if (typeof v !== 'string') return 0;
    var s = v.replace(/[\s$]/g, '');
    // A comma counts only as a thousands separator: "1,5" is not 15 (COD Domain).
    if (s.indexOf(',') >= 0 && !/^[-+]?\d{1,3}(,\d{3})+(\.\d*)?$/.test(s)) return 0;
    var n = Number(s.replace(/,/g, ''));
    return isFinite(n) ? n : 0;
  }

  window.Moneyish = Object.freeze({ parse: parseMoneyish });
})();
